// Flow types automatically removed

import { postToIframe } from 'dibs-xdomain-poster';
import { photoPaths } from './WorkspaceMatchmaker/FormStepInspiration.jsx';
import {
    FULL_ARCHITECTURE_DESIGN,
    FULL_HOUSE_DESIGN,
    DESIGN_COUPLE_ROOMS,
    DESIGN_SINGLE_ROOM,
    HELP_SINGLE_ITEM,
} from './constants.js';
import { trackSendInformationComplete } from './matchmakerTracking.js';

const checkboxElement = ({ checked, name }) => {
    const element = document.createElement('input');
    element.type = 'checkbox';
    element.name = name;
    element.checked = checked;
    return element;
};

export function postToFA({ state, shouldTrackGA }) {
    const {
        budget,
        color,
        country,
        email,
        firstName,
        lastName,
        layer,
        phone,
        postalCode,
        projectScopes,
        selectedPhotos,
        time,
        tellUsMore,
        userId,
    } = state;
    return postToIframe('https://www.tfaforms.com/responses/processor', {
        /* eslint-disable camelcase */
        tfa_1: userId,
        tfa_2: firstName,
        tfa_3: lastName,
        tfa_4: email,
        tfa_5: budget,
        tfa_7: postalCode,
        tfa_8: country,
        tfa_10: checkboxElement({
            checked: projectScopes.includes(FULL_ARCHITECTURE_DESIGN),
            name: 'tfa_10',
        }),
        tfa_11: checkboxElement({
            checked: projectScopes.includes(FULL_HOUSE_DESIGN),
            name: 'tfa_11',
        }),
        tfa_12: checkboxElement({
            checked: projectScopes.includes(HELP_SINGLE_ITEM),
            name: 'tfa_12',
        }),
        tfa_13: checkboxElement({
            checked: projectScopes.includes(DESIGN_COUPLE_ROOMS),
            name: 'tfa_13',
        }),
        tfa_14: checkboxElement({
            checked: projectScopes.includes(DESIGN_SINGLE_ROOM),
            name: 'tfa_14',
        }),
        tfa_15: phone,
        tfa_16: tellUsMore,
        tfa_17: time,
        tfa_26: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[0]),
            name: 'tfa_26',
        }),
        tfa_27: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[1]),
            name: 'tfa_27',
        }),
        tfa_28: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[2]),
            name: 'tfa_28',
        }),
        tfa_29: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[3]),
            name: 'tfa_29',
        }),
        tfa_30: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[4]),
            name: 'tfa_30',
        }),
        tfa_31: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[5]),
            name: 'tfa_31',
        }),
        tfa_32: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[6]),
            name: 'tfa_32',
        }),
        tfa_33: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[7]),
            name: 'tfa_33',
        }),
        tfa_34: checkboxElement({
            checked: selectedPhotos.includes(photoPaths[8]),
            name: 'tfa_35',
        }),
        tfa_35: color,
        tfa_36: layer,
        tfa_dbFormId: 4681865,
        tfa_dbResponseId: '',
        tfa_dbControl: '7fc839b047781aad884433faa0421e76',
        tfa_dbTimeStarted: Date.now(),
        tfa_referrer: window.location.href,
        tfa_dbVersionId: 7,
        tfa_switchedoff: '',
        /* eslint-enable camelcase */
    }).then(() => {
        if (shouldTrackGA) {
            trackSendInformationComplete();
        }
    });
}
